import { useTranslation } from "react-i18next";

export const useServices = (availableApps = []) => {
    const { t } = useTranslation();

    const apps = Array.isArray(availableApps) ? availableApps : [availableApps];

    const allServices = [
        {
            code: "hv",
            title: t("services.healthview.title"),
            description: t("services.healthview.description"),
            link: process.env.REACT_APP_HEALTHVIEW_URL,
            icon: "/assets/Healthview.png",
        },
        {
            code: "cf",
            title: t("services.cleverflow.title"),
            description: t("services.cleverflow.description"),
            link: process.env.REACT_APP_CLEVERFLOW_URL,
            icon: "/assets/CleverFlow.png",
        },
        {
            code: "sgfe",
            title: t("services.powerprescription.title"),
            description: t("services.powerprescription.description"),
            link: process.env.REACT_APP_POWERPRESCRIPTION_URL,
            icon: "/assets/PowerPrescription.png",
        },
        {
            code: "bi",
            title: t("services.businessinsight.title"),
            description: t("services.businessinsight.description"),
            link: process.env.REACT_APP_BUSINESSINSIGHT_URL,
            icon: "/assets/BusinessInsight.png",
        },
    ];

    if (apps.length === 0) {
        return allServices;
    }

    return allServices.filter((service) => apps.includes(service.code));
};
